<template>
  <div>
    <v-autocomplete
      outlined
      v-if="readonly === false"
      dense
      v-model="select"
      :items="lista"
      item-text="Descripcion_seccional"
      item-value="id_seccional"
      label="Seccional"
      persistent-hint
      return-object
      @change="$emit('input', select.id_seccional)"
      hide-details
    ></v-autocomplete>
    <v-text-field
      outlined
      dense
      label="Seccional"
      v-if="readonly===true"
      readonly
      filled
      :value="select.Descripcion_seccional"
      hide-details
    ></v-text-field>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      select: {
        id_seccional: 0,
        Descripcion_seccional: ""
      }
    };
  },
  computed: {
    ...mapState("seccionales", ["Lista"]),
    lista: function() {
      let l = [...this.Lista];
      l.unshift({
        id_seccional: 0,
        Descripcion_seccional: " --Seleccione-- "
      });
      return l;
    }
  },
  methods: {
    seleccionar(id) {
      if (id !== null) {
        let pr = this.lista.find(x => x.id_seccional == id);
        if (pr) {
          this.select = pr;
        } else {
          this.seleccionar("0");
        }
      }
    }
  },
  async mounted() {
    let id = this.value;
    this.seleccionar(id);
  },
  watch: {
    value() {
      this.seleccionar(this.value);
    }
  }
};
</script>

<style>
</style>